import { EventManagement } from '@/components/events/event-management';
import LoadingSpinner from '@/components/loading/loading-spinner';
import { useFlags } from '@/context/feature-flags';
import DataTableContainer from '../data-table-container';
import EventTable from '../tables/event/event-table';

function Events() {
  // TODO - Remove feature flag when no longer needed
  const { flags } = useFlags();

  if (!flags) {
    return <LoadingSpinner text='Events' />;
  }

  const eventTableFlag = flags['event-table-upgrade'];

  if (eventTableFlag) {
    return <EventManagement />;
  } else {
    return (
      <DataTableContainer>
        <EventTable />
      </DataTableContainer>
    );
  }
}

export default Events;
